import { gql } from '@apollo/client';

export const RequestPasswordResetQuery = gql`
  mutation RequestPasswordReset($email: String!, $lang: String!, $productAbbreviation: String, $redirectUrl: String!) {
    requestPasswordReset(
      email: $email
      productAbbreviation: $productAbbreviation
      lang: $lang
      redirectUrl: $redirectUrl
    )
  }
`;
